import { observer } from 'mobx-react';
import { FC } from 'react';
import { useForm, withForm } from 'react-bootstrap-formutil';
import AgreementInfo from 'components/forms/AgreementInfo';
import { getFullName } from 'components/forms/RealNameInfo';
import { usePowerNavigate } from 'components/PowerNavigate';
import Toast from 'components/Toast';
import security from 'stores/security';
import values from 'stores/values';
import { CustomerInfoType, LicenseEnum } from 'types/customer';
import { modifyCustomerInfo } from 'utils/request';
import Container from '../components/Container';

const Agreements: FC = () => {
    const navigate = usePowerNavigate();
    const { currentCustomerId } = security;
    const { $params } = useForm<CustomerInfoType>();
    const { account_capabilities, opt_perm, treasury_perm, category } = $params;
    const name = getFullName($params);

    const handleSubmit = async () => {
        Toast.loading(true);

        try {
            await modifyCustomerInfo({
                extra: {
                    assisted_opening_ack: true
                }
            });

            // 获取最新开户状态
            await security.getOpenProcess(currentCustomerId);
            sessionStorage.removeItem('temporaryConfirmFPSLAgreement');

            navigate('../../complete', { replace: true });
        } catch (error) {
            Toast.show(error);
        }

        Toast.loading(false);
    };

    return (
        <Container
            onSubmit={handleSubmit}
            footerButtonsProps={{
                nextBtnProps: {
                    content: __('Submit')
                },
                hidePrev: false
            }}>
            <AgreementInfo
                license={LicenseEnum.MARSCO}
                name={name}
                accountCapability={account_capabilities}
                perms={{ opt_perm, treasury_perm }}
                category={category}
            />
        </Container>
    );
};

export default withForm(observer(Agreements), {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
